import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';
import { ApiService } from '../../../services/api.service';
import { SimpleUIObjectDTO } from '../../../models/series.model';
import { SocialLink } from '../header-controls/header-controls.component';

interface SocialLinkData {
  icon: string;
  url: string;
}

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  
  @Input() metrics: SimpleUIObjectDTO[] = [];
  @Input() showMetrics: boolean = false;
  @Input() customBackgroundImage?: string;
  
  data = {
    bannerImageUrl: '/assets/images/banner-main.png',
    name: 'ISTANBUL UNIVERSITY PRESS',
    subTitle: 'subTitle',
    slug: 'slug',
    socialLinks: [
      { icon: 'fab fa-instagram', url: 'https://www.instagram.com/istunipress/' },
      { icon: 'fab fa-linkedin-in', url: 'https://www.linkedin.com/company/iupress/' },
      { icon: 'fab fa-x', url: 'https://twitter.com/istunipress' },
    ] as SocialLinkData[]
  };

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    if (this.customBackgroundImage) {
      this.data.bannerImageUrl = this.customBackgroundImage;
    }
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  // Get social links for header controls
  getSocialLinks(): SocialLink[] {
    return this.data.socialLinks.map(link => ({
      url: link.url,
      icon: link.icon,
      name: this.getSocialPlatformName(link.icon)
    }));
  }

  // Get platform name from icon class
  private getSocialPlatformName(iconClass: string): string {
    if (iconClass.includes('instagram')) return 'Instagram';
    if (iconClass.includes('linkedin')) return 'LinkedIn';
    if (iconClass.includes('twitter') || iconClass.includes('fa-x')) return 'Twitter';
    if (iconClass.includes('facebook')) return 'Facebook';
    if (iconClass.includes('youtube')) return 'YouTube';
    return 'Social Media';
  }

  changeLang(lang: string): void {
    this.languageService.setLanguage(lang);
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  navigateToHome(): void {
    this.router.navigate(['/']);
  }

  navigateToJournals(): void {
    this.router.navigate(['/search/journal']);
  }

  navigateToBooks(): void {
    this.router.navigate(['/search/book']);
  }

  navigateToSeries(): void {
    this.router.navigate(['/search/series']);
  }

  navigateToConferences(): void {
    this.router.navigate(['/search/conference'], {
      queryParams: {
        type: 'book',
        book_type: '35005100410055006B0063006A0054006D00420073003100'
      }
    });
  }

  navigateTo100Anniversary(): void {
    this.router.navigate(['/search/book'], {
      queryParams: {
        type: 'book',
        book_type: '46007400380059004A004F00540034007100740041003100'
      }
    });
  }

  openSocialLink(url: string): void {
    window.open(url, '_blank');
  }

  toggleMobileNav(): void {
    const navElement = document.getElementById('header-sub-nav');
    if (navElement) {
      navElement.classList.toggle('show');
    }
  }
}
